.container {
    padding: 0 3%;
}
